import React, {useEffect, useState} from "react";
import PreSelectedParlaysBanners from "../PreSelectedParlaysView/PreSelectedParlaysBanners";
import FilterBarDesktop from "../../components/FilterBar/FilterBar.Desktop";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import {FormattedMessage} from "react-intl";
import ContestCard from "../../components/ContestCard/ContestCard";

const CreateOwnParlayViewDesktop = ({vm})=>{
    const [isFilterBarOpen, setFilterBarOpen] = useState(false);

    useEffect(() => {
        if( vm.preSelectedParlayBannersExists ){
            setFilterBarOpen(false);
        }else{
            setFilterBarOpen(true);
        }
    }, [vm.preSelectedParlayBannersExists]);

    return (<div className="CreateOwnParlayView desktop">
            <div className={`bannersAndFilterBar ${vm.preSelectedParlayBannersExists ? "banners" : ""}`}>

                {<PreSelectedParlaysBanners isOpen={!isFilterBarOpen}
                                            setPreSelectedParlayBannersExists={vm.setPreSelectedParlayBannersExists}/>}

                <FilterBarDesktop isFilterBarOpen={isFilterBarOpen}
                                    setFilterBarOpen={setFilterBarOpen}
                                    vm={vm}/>
            </div>

            {vm.isLoading &&  <div className="loading">{<LoadingSpinner/>}</div>}
            {vm.filteredContests.length === 0 && !vm.isLoading?
                <div className="noPlayers"><FormattedMessage id={"lobbyView.createOwnParlayView.noPlayers"}/></div>
                :
                <div className="cards">
                    {vm.filteredContests?.map((contest, index) => (
                        <ContestCard key={contest.Id}
                                     contest={contest}
                                     disabled={!vm.canAdd(contest.Id)}
                        />
                    ))}
                </div>}
        </div>
    )

}

export default CreateOwnParlayViewDesktop;